module.exports = __webpack_public_path__ + "img/Classifier1.cb2521b4.png";